import { filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';
let url = process.env.REACT_APP_API_URL;

export const surchargesService = {
    getSurcharges: async (params) => {
      const response = await authInstance
        .get(`${url}/parameters/discountSurcharge?` + new URLSearchParams(filterParams(params)))
        .then(async (response) => {
          return response;
        })
        .catch(function (error) {
          console.log('error', error);
          error.data = [];
          return error;
        });
      return response;
    },
      updateSurcharge: async (surchargeId, data) => {
        const response = await authInstance
          .put(`${url}/parameters/discountSurcharge/${surchargeId}`, data)
          .then(async (response) => {
            return response;
          })
          .catch(function (error) {
            error.data = [];
            return error;
          });
        return response;
      },
      createSurcharge: async (data) => {
        const response = await authInstance
          .post(`${url}/parameters/discountSurcharge`, data)
          .then(async (response) => {
            return response;
          })
          .catch(function (error) {
            error.data = [];
            return error;
          });
        return response;
      },
      discountSurchargeAppliesToMembership: async (params) => {
        // ? this method have memId
      const response = await authInstance
        .get(`${url}/parameters/discountSurchargeAppliesToMembership?` + new URLSearchParams(filterParams(params)))
        .then(async (response) => {
          return response;
        })
        .catch(function (error) {
          console.log('error', error);
          error.data = [];
          return error;
        });
      return response;
    },
};
